import { FormSelect, FormSelectOption } from '@patternfly/react-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { MVisionAppClient } from '../store/mvision-client-list';
import { setCurrentAppClient, StoreState } from '../store/reducers';
import { getCurrentAppClient, selectAnyUnsavedChangesInApp } from '../store/selectors';

import './client-selector.css';

const ClientSelector = (props: { clientList: MVisionAppClient[] }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const currentAppClient = useSelector(getCurrentAppClient);
    const anyUnsavedChanges = useSelector(selectAnyUnsavedChangesInApp);
    const isClientDataOperationInProgress = useSelector((state: StoreState) => state.isFetchingClientData || state.isModelCustomizationDeleteInProgress);

    const changeAppClient = (newAppClientId: string) => {
        if (newAppClientId !== currentAppClient?.userId) {
            const newValue = newAppClientId === '' ? undefined : newAppClientId;

            // prompt user to confirm if there are unsaved changes
            if (newValue !== currentAppClient?.userId && anyUnsavedChanges && !window.confirm(t('confirm.changeConfigurationTarget') as string)) {
                return;
            }

            dispatch(setCurrentAppClient(newValue));
        }
    }

    // initialize client selector with an empty value, but only if we have more than 1 value in the original data
    const dropdownValues: (MVisionAppClient | { userId: undefined, userName: string })[] = props.clientList.length > 1 ? [{ userId: undefined, userName: '' }] : [];
    props.clientList.forEach(cl => dropdownValues.push(cl));

    return (
        <div className="client-selector">
            <div className="client-selector-label">{t('topMenu.configurationTarget')}</div>
            <div>
                <FormSelect
                    value={dropdownValues.find(ddv => ddv.userId === currentAppClient?.userId)?.userId}
                    onChange={changeAppClient}
                    id="app-client-selector-form"
                    name="app-client-selector-form"
                    isDisabled={isClientDataOperationInProgress}
                    data-test='config-target'
                    >
                    {dropdownValues.map(cl => (
                        <FormSelectOption data-test='config-target-item' data-testid={cl.userName} key={cl.userId || 0} value={cl.userId} label={cl.userName} />
                    ))}
                </FormSelect>
            </div>
        </div>
    );
}

export default ClientSelector;
